/*eslint @typescript-eslint/no-unused-vars: "off"*/
/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @interface FormQuestionFeedbackCreate
 */
export interface FormQuestionFeedbackCreate {
    /**
     * 
     * @type {number}
     * @memberof FormQuestionFeedbackCreate
     */
    question_mapping_pos: number;
    /**
     * Collection of feedback options for question mapping feature.
     * @type {string}
     * @memberof FormQuestionFeedbackCreate
     */
    rating: FormQuestionFeedbackCreateRatingEnum;
    /**
     * 
     * @type {number}
     * @memberof FormQuestionFeedbackCreate
     */
    response_pos?: number;
    /**
     * 
     * @type {string}
     * @memberof FormQuestionFeedbackCreate
     */
    response_value?: string;
    /**
     * 
     * @type {string}
     * @memberof FormQuestionFeedbackCreate
     */
    source_question_id: string;
}




/**
* @export
* @enum {string}
*/
export enum FormQuestionFeedbackCreateRatingEnum {
    RESPONSEAPPLIED = 'RESPONSE_APPLIED',
    THUMBSDOWN = 'THUMBS_DOWN',
    THUMBSUP = 'THUMBS_UP'
}


